import React from 'react'
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import { ENTER } from '../assets/constants/Constants';
import useGeoLocation from "react-ipgeolocation";

const CustomMobileInput = ({handleSetMobile,value,handleKeyDown,hasError,disabled,autoFocus}) => {
    const { t } = useTranslation();
    const location = useGeoLocation();

    const handleKeyEvents = (event) => {
        if(event.key === ENTER){
            if(!disabled){
                handleKeyDown();
                event.target.blur()
            }
        }
    };

    return (
       <>
       <p className='phone-paragraph'>{t('enter_your_phone_number_label')}</p>
        <PhoneInput
        country={location?.country || 'in'}
        value={value}
        inputClass={`phoneInput ${hasError ? 'error-border' : ''}`}
        dropdownStyle={{color : 'black'}}
        specialLabel=''
        placeholder={t('enterMobileNumber')}
        onChange={handleSetMobile}
        countryCodeEditable={false}
        onKeyDown={(event) => handleKeyEvents(event)}
        inputProps={{
        autoFocus: autoFocus,
        }}
        />
       </>
        
  )
}

export default CustomMobileInput;
